module.exports = __webpack_public_path__ + "static/media/blown-out.58c6fcf1.svg";